import { motion } from "framer-motion";
import { Building2, Scan, HeartPulse, TrendingUp, Sparkles } from "lucide-react";
import { SECTORS } from "@/lib/data";
import { Reveal } from "@/components/Reveal";

const ICONS = { building2: Building2, scan: Scan, heartPulse: HeartPulse, trendingUp: TrendingUp };

export default function Sectors() {
  return (
    <section id="sectors" className="py-24 lg:py-32 bg-white" data-testid="sectors-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-10">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-10">
          <div>
            <Reveal>
              <div className="text-[11.5px] uppercase tracking-[0.22em] text-medis-teal font-semibold">Sectors We Support</div>
              <h3 className="mt-3 font-display font-bold text-medis-navy text-2xl sm:text-3xl lg:text-[30px] leading-[1.15] tracking-tight max-w-4xl">
                Structured support for every kind of imaging facility
              </h3>
            </Reveal>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-5">
          {SECTORS.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <motion.div
                key={s.number}
                initial={{ opacity: 0, y: 28 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.15 }}
                transition={{ duration: 0.6, delay: Math.min(i * 0.08, 0.3) }}
                className="group relative rounded-xl border border-medis-silver/30 bg-white p-7 overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
                data-testid={`sector-card-${s.number}`}
              >
                <div
                  className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                  style={{ background: `radial-gradient(circle at 80% 0%, ${s.accent}0d, transparent 60%)` }}
                />
                <div className="relative flex items-start justify-between gap-4">
                  <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl" style={{ background: `${s.accent}1a` }}>
                    <Icon className="h-5 w-5" style={{ color: s.accent }} />
                  </div>
                  <div className="font-display font-bold text-[40px] leading-none opacity-[0.07]" style={{ color: s.accent }}>
                    {s.number}
                  </div>
                </div>
                <h3 className="relative mt-5 font-display font-semibold text-medis-navy text-[18px] leading-snug">{s.label}</h3>
                <p className="relative mt-2.5 text-[13.5px] text-medis-gray leading-relaxed">{s.text}</p>
                <div
                  className="relative mt-5 inline-flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-[0.1em] px-3 py-1.5 rounded-full border"
                  style={{ background: s.accent + "14", color: s.accent, borderColor: s.accent + "1f" }}
                >
                  <Sparkles className="h-3 w-3" /> {s.tag}
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
